import { getInitialState } from "./state.js";
import { ActionTypes } from "./actions.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.fetch:
            return {
                ...state,
                searchAiSummary: {},
                fetchStatus: "loading",
                error: undefined
            };
        case ActionTypes.fetchSuccess:
            return {
                ...state,
                searchAiSummary: action.payload.data,
                fetchStatus: "success",
                error: undefined
            };
        case ActionTypes.fetchError:
            return {
                ...state,
                fetchStatus: "failed",
                error: action.payload.error,
                searchAiSummary: undefined
            };
        default:
            return {
                ...state
            };
    }
};
export { reducer, getInitialState };
